export default (app, elementScope) => {
  const elements = Array.prototype.slice.call(elementScope.querySelectorAll('[data-controller="word-split"]'));

  elements.forEach((element) => {
    const controller = app.getControllerForElementAndIdentifier(element, 'word-split');

    if (!controller) {
      return;
    }

    controller.trigger();
  });
};
